/* import __COLOCATED_TEMPLATE__ from './rest-bom-source.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();